@for (item of content; track item) {
  <app-product-detail-item
    [product]="product"
    [config]="item"
  ></app-product-detail-item>
}
